import AmexCardsComparator from '@blocks/amex-cards-comparator/amex-cards-comparator'
import BankFeesComparator from '@blocks/bank-fees-comparator'
import BlockFourCustomersReviews from '@blocks/block-four-customers-reviews'
import BlockSixCustomersReviews from '@blocks/block-six-customers-reviews'
import { BorrowerInsuranceSavingsSimulator } from '@blocks/borrower-insurance-savings-simulator/borrower-insurance-savings-simulator'
import Comparator from '@blocks/cards-comparator/comparator'
import ComparatorLight from '@blocks/cards-comparator-light/comparator-light'
import MortgageSimulator from '@blocks/mortgage-simulator/mortgage-simulator'
import PerExempleFiscalite from '@blocks/per-exemple-fiscalite/per-exemple-fiscalite'
import VerifiedReviews from '@blocks/verified-reviews'
import { withDisplayName } from '@hocs/with-display-name'
import { type IStaticBlockFields } from '@typings/contentful.readonly'
import { graphql } from 'gatsby'
import React from 'react'

const templateMapping: Utils.Object<any, IStaticBlockFields['type']> = {
  'avis-vérifiés': VerifiedReviews,
  'bloc-4-avis-clients': BlockFourCustomersReviews,
  'bloc-6-avis-clients': BlockSixCustomersReviews,
  'comparateur-cartes': Comparator,
  'comparateur-cartes-allégé': ComparatorLight,
  'comparateur-cartes-allégé-compte-joint': () => <ComparatorLight isShared />,
  'comparateur-cartes-compte-joint': () => <Comparator isShared />,
  'comparateur-frais-bancaires': BankFeesComparator,
  'simulateur-credit': MortgageSimulator,
  'tableau-amex': AmexCardsComparator,
  'per-exemple-fiscalité': PerExempleFiscalite,
  'simulateur-gain-assurance-emprunteur': BorrowerInsuranceSavingsSimulator,
}

const ContentfulStaticBlock: Utils.EntryFC<
  Queries.ContentfulStaticBlockFragment
> = ({ content: { type }, entryInspectorProps, fieldInspectorProps }) => {
  const Template = templateMapping[type as IStaticBlockFields['type']]

  return (
    <div
      className="w-full"
      id={type}
      {...entryInspectorProps()}
      {...fieldInspectorProps({
        fieldId: 'type',
      })}
    >
      <Template />
    </div>
  )
}

export const query = graphql`
  fragment ContentfulStaticBlock on ContentfulStaticBlock {
    ...ContentfulEntry
    type
  }
`

export default withDisplayName(ContentfulStaticBlock, 'ContentfulStaticBlock')
